import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { UmbrellaLogo } from "@/components/UmbrellaLogo";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        <UmbrellaLogo size={40} className="animate-pulse" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
